import { fetchMatchups } from '../api/api';
import { useQuery} from 'react-query'
import RouteUtils from '../utils/routeUtils'
import { useState, useEffect } from 'react';
import {useWebsocket} from '../components/socketContext/socketContext';
import {subscribeApiSocket} from '../api/socket';
import _ from 'lodash';

export const useMatchupsQuery = (league) => {
    const leagueFilter = RouteUtils.getLeague(league);
    const [enabled, setEnabled] = useState(true);
    const socket = useWebsocket();
    const { isLoading, data } = useQuery([league], () => fetchMatchups(leagueFilter), {enabled});
    const [matchups, setMatchups] = useState(data || []);

    const onSocketMessage = (m) => {
        let data = JSON.parse(m.data);

        if (!data || !data.matchupId) {
            console.warn(`Socket ignoring unexpected message: ${JSON.stringify(data)}`);
            return;
        }

        setMatchups((games) => {
            const newGames = [...games];
            newGames.forEach(game => {
                if (game.id === data.matchupId) {
                    if (data.eventName === 'status_updated') {
                        game = {...game, ...data.data};
                    }
                }
            });

            return newGames;
        });
    }

    useEffect(() => {
        socket.addEventListener('message', onSocketMessage);

        return () => {
            socket.removeEventListener('message', onSocketMessage);
        }
    }, []);

    useEffect(() => {
        const games = data || [];

        const sortedGamesByDate = _.orderBy(games, g => {
            return new Date(g.scheduled_datetime);
        });
        const sortedGamesByComplete = _.orderBy(sortedGamesByDate, g => {
            return g.status === 'complete'
        }, ["asc"]);
        const sortedGamesByClosed = _.orderBy(sortedGamesByComplete, g => {
            return g.status === 'closed'
        }, ["asc"]);
        const sortedGamesByPostponed = _.orderBy(sortedGamesByClosed, g => {
            return g.status === 'postponed'
        }, ["asc"]);
        const sortedGamesBySchedule = _.orderBy(sortedGamesByPostponed, g => {
            return g.status === 'cancelled'
        }, ["asc"]);

        setMatchups(sortedGamesBySchedule);

        if (data && data.length) {
            setEnabled(false);
        }

    }, [data, isLoading]);

    return { isLoading, matchups };
}